import { render, staticRenderFns } from "./AdminPrepaidDashboard.vue?vue&type=template&id=2ce8d569&scoped=true&"
import script from "./AdminPrepaidDashboard.vue?vue&type=script&lang=js&"
export * from "./AdminPrepaidDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AdminPrepaidDashboard.vue?vue&type=style&index=0&id=2ce8d569&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce8d569",
  null
  
)

export default component.exports